module.exports = __webpack_public_path__ + "img/xjb-adv2.jpg";